import data from "./StatTableData";

export default {
  ...data,
  props: {
    tablename: String,
    tabledata: Array,
    tabletype: String,
    tabletotal1: String,
    tabletotal2: String,
  },
  computed: {},
  filters: {
    formatAmt: function(value) {
      if (value) {
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
  },
  methods: {
    itemSelected() {
      this.$emit("updateSelectedItem", this.selectedItems);
    },
  },
  mounted() {
    this.selectedItems = this.tabledata;
  },
};
